// BCM-898 · PA2 — Review of low confidence fields (slide 7). [Uday]
// Status 5 AND reviewPostMFGFieldsReqd (also 45/50 with reviewPreShipmentFieldsReqd
// / reviewPostShipmentFieldsReqd). Renders the real CommonDigitizedDocument
// INLINE (mockup slide 7): document tabs — every document of the category under
// review (pa2CategoryFor: Post-Manufacturing — Certificate of Manufacture /
// Consumption Details / … — or Pre-/Post-Shipment) — with review-count
// badges, Sync Inventory / Sync PO / Resubmit Document on the tab row, and
// CommonDigitizedDocument's own field pane + PDF/Excel preview + Mark review as
// complete. No Dialog wrapper, no product-details ribbon — see
// GRDigitalizedDocumentReview. Sync buttons here do NOT force a reset (V5).
//
// Also doubles as the pre-/post-shipment review screen (statuses 45/50,
// reviewPreShipmentFieldsReqd / reviewPostShipmentFieldsReqd) — same component,
// category switched to match which flag is actually set so the Pre-/Post-Shipment
// documents show instead of Post-Manufacturing's. The batch row reads "Review
// pending" until the detail loads, then "N Low Confidence Fields" — or, for an ASN
// batch (IDoc-sourced Production / Post Shipment ASN), "Post-MFG review pending" /
// "Delivery ASN review pending" (resolvePendingAction.labelFor).
import React from "react";
import GRDigitalizedDocumentReview from "../components/common/GRDigitalizedDocumentReview";
import SyncActions from "../components/common/SyncActions";
import ResubmitDocumentButton from "../components/common/ResubmitDocumentButton";
import { pa2CategoryFor } from "../utils/reviewDocs";
import { useGRStyles } from "../goodsReceiptStyles";

const PA2ReviewFields = ({ row, detail, featuresAccess, viewOnly, onRefresh }) => {
  const classes = useGRStyles();
  return (
    <div className={classes.section}>
      <GRDigitalizedDocumentReview
        row={row}
        detail={detail}
        onRefresh={onRefresh}
        category={pa2CategoryFor(row)}
        viewOnly={viewOnly}
        headRight={(active) => (
          <React.Fragment>
            <SyncActions
              row={row}
              detail={detail}
              featuresAccess={featuresAccess}
              showSyncInventory
              showSyncPO
              resetsBatchInventory={true}
              resetsBatchPO={true}
              onRefresh={onRefresh}
            />
            <ResubmitDocumentButton
              row={row}
              detail={detail}
              featuresAccess={featuresAccess}
              onAfter={onRefresh}
              blue
              activeDocType={active && active.docType}
            />
          </React.Fragment>
        )}
      />
    </div>
  );
};

export default PA2ReviewFields;
